export const refs = {
  spinner: document.querySelector('.centered-element'),
  homeCategoryBooksList: document.querySelector('.js-home-category-books-list'),
  homeObserverTarget: document.querySelector('.js-guard'),
  homeMainScrollUp: document.querySelector('.js-home-main-scroll-up'),
  homeButtonsSeeMore: document.getElementsByClassName('home-see-more-btn'),
  homeMainTitle: document.querySelector('.home-main-title'),
  homeMainTitleAccent: document.querySelector('.home-main-title-accent'),

  homeBookTitles: document.getElementsByClassName('home-books-book-title'),
  categoriesList: document.querySelector('.categories-list'),

  categoriesContainer: document.querySelector('.js-categories-list'),
  categoriesContainerItem: document.querySelector('.js-categories-list-item'),

  toggleEl: document.querySelector('#theme-switcher'),
  bodyEl: document.querySelector('body'),

  switcherEl: document.querySelector('.js-dark-switcher'),

  btnOpenModalLogin: document.querySelector('.header__menu-login'),
  modalLogin: document.querySelector('#login-modal'),
  btnCloseModalLogin: document.querySelector('.modal-close-btn'),
  btnSignUp: document.querySelector('[data-sign="up"]'),
  btnSignIn: document.querySelector('[data-sign="in"]'),
  btnGoogle: document.querySelector('[name="submitUpBtn"]'),
  inputName: document.querySelector('[name="username"]'),
  switcherCircle: document.querySelector('.switcher-input'),
  btnOpenBurgerMenu: document.querySelector('.js-open-menu'),
  headerNav: document.querySelector('.header__nav'),
  btnAddShoppinfList: document.querySelector('#js-book-modal-btn'),
  supportUkraineAside: document.querySelector('.support-box'),
  headerHomeBtn: document.querySelectorAll('.js-nav__list-home'),
  headerShoppingListBtn: document.querySelectorAll('.js-nav__list-sl'),
};
